export const pt: Record<string, string> = {
  // Navbar
  'navbar.products': 'Produtos',
  'navbar.useCases': 'Casos de uso',
  'navbar.pricing': 'Preços',
  'navbar.about': 'Sobre',
  'navbar.contact': 'Contacto',
  'navbar.bookDemo': 'Agendar uma demo',
  'navbar.tripppMap': 'Trippp Map',
  'navbar.tripppSpark': 'Trippp Spark',
  'navbar.tripppTripOps': 'Trippp Ops',
  'navbar.dmosAndTourismBoards': 'OGD e Organismos de turismo',
  'navbar.dmcsAndTravelAgencies': 'DMC e Agências de viagem',
  'navbar.hotelsAndResorts': 'Hotéis e Resorts',
  'navbar.realEstateAndLifestyle': 'Imobiliário e Lifestyle',

  // Hero
  'hero.title': 'Impulsione a jornada completa',
  'hero.subtitle':
    'A plataforma tecnológica modular para o turismo que impulsiona tudo, desde o primeiro desejo até ao último dia no terreno.',
  'hero.bookDemo': 'Agendar uma demo',
  'hero.exploreProducts': 'Explorar produtos',

  // Social Proof
  'socialProof.trusted': 'Destinos e agências de todo o mundo confiam em nós',

  // Product Suite
  'productSuite.title': 'Uma plataforma. Três produtos.',
  'productSuite.subtitle':
    'Arquitetura modular desenhada para escalar com o seu negócio turístico.',
  'productSuite.learnMore': 'Saber mais',
  'productSuite.mapName': 'Trippp Map',
  'productSuite.mapDesc':
    'Um mapa interativo de destino em marca branca. Pontos de interesse, itinerários, trilhos de caminhada e conteúdo multilingue — tudo gerido através de um CMS dedicado.',
  'productSuite.sparkName': 'Trippp Spark',
  'productSuite.sparkDesc':
    'Uma experiência de descoberta cinematográfica baseada em emoções. Os viajantes exploram um destino emocionalmente antes de reservar um voo.',
  'productSuite.opsName': 'Trippp Ops',
  'productSuite.opsDesc':
    'Uma app para viajantes e plataforma operacional num só. Em marca branca por viagem, oferece aos viajantes o programa completo enquanto dá às agências visibilidade total sobre extras e comissões.',

  // Persona Tabs
  'personaTabs.sectionTitle': 'Construído para a sua indústria.',
  'personaTabs.tab0Label': 'OGD e Organismos de turismo',
  'personaTabs.tab1Label': 'DMC e Agências de viagem',
  'personaTabs.tab2Label': 'Hotéis e Resorts',
  'personaTabs.tab3Label': 'Promotores imobiliários e Lifestyle',
  'personaTabs.content0Title':
    'Coloque o seu destino no mapa digital — literalmente.',
  'personaTabs.content0Desc':
    'Ofereça aos visitantes uma janela interativa e multilingue para tudo o que a sua região oferece. De trilhos escondidos a itinerários selecionados, Trippp Map e Spark transformam qualquer destino numa experiência digital de classe mundial — totalmente com a sua marca.',
  'personaTabs.content0Feature0': 'Mapa interativo de destino com CMS',
  'personaTabs.content0Feature1': 'Experiência de descoberta cinematográfica',
  'personaTabs.content0Feature2':
    'Multilingue — impulsionado por IA, qualquer idioma',
  'personaTabs.content1Title':
    'Operações mais eficientes. Mais mandatos internacionais.',
  'personaTabs.content1Desc':
    'Trippp Ops oferece à sua agência uma app para viajantes em marca branca para cada operação — marketplace de extras, documentos, programa, contactos de emergência. Os parceiros internacionais escolhem-no porque oferece uma transparência em que podem confiar.',
  'personaTabs.content1Feature0':
    'App para viajantes em marca branca por viagem',
  'personaTabs.content1Feature1': 'Marketplace de extras e comissões',
  'personaTabs.content1Feature2': 'Visibilidade operacional em tempo real',
  'personaTabs.content2Title':
    'Mostre aos hóspedes o que os rodeia antes de chegarem.',
  'personaTabs.content2Desc':
    'Integre Spark diretamente no seu site. Deixe os futuros hóspedes explorar a sua propriedade e o destino envolvente através de uma experiência cinematográfica que nenhuma galeria estática consegue igualar.',
  'personaTabs.content2Feature0': 'Experiência cinematográfica integrável',
  'personaTabs.content2Feature1': 'Montra de propriedade orientada ao destino',
  'personaTabs.content2Feature2': 'Engagement imersivo pré-chegada',
  'personaTabs.content3Title': 'Venda o estilo de vida, não apenas o imóvel.',
  'personaTabs.content3Desc':
    'Map e Spark oferecem aos seus compradores uma vista imersiva do destino onde estão a investir — trilhos, restaurantes, cultura, experiências. O ambiente torna-se parte do argumento.',
  'personaTabs.content3Feature0': 'Cartografia imersiva de destino',
  'personaTabs.content3Feature1':
    'Experiência de comprador orientada ao lifestyle',
  'personaTabs.content3Feature2': 'O ambiente como argumento de venda',

  // Use Cases
  'useCases.sectionTitle': 'Veja no mundo real.',
  'useCases.case0Label': 'Organismo de turismo',
  'useCases.case0Title': 'Visit Beni Mellal-Khénifra',
  'useCases.case0Desc':
    'Um organismo de turismo regional em Marrocos implementou Trippp Map e Spark para digitalizar um destino anteriormente pouco promovido — oferecendo aos visitantes uma janela interativa e multilingue para as montanhas, vales e cultura da região.',
  'useCases.case1Label': 'Organismo de turismo',
  'useCases.case1Title': 'Visit Draa-Tafilalet',
  'useCases.case1Desc':
    'A porta de entrada para o Saara em Marrocos agora tem um mapa interativo que cobre o seu vasto território — cidades, oásis, kasbahs e rotas de trekking, tudo completamente multilingue.',
  'useCases.case2Label': 'DMC',
  'useCases.case2Title': 'Lumi Morocco',
  'useCases.case2Desc':
    'Um DMC marroquino implementou Trippp Ops para oferecer aos viajantes dos seus clientes internacionais uma experiência de viagem totalmente com marca — programa, extras, documentos e comunicação em tempo real, tudo sob a marca Lumi.',
  'useCases.explore': 'Explorar',
  'useCases.comingSoon': 'Em breve',

  // How It Works
  'howItWorks.title': 'Como funciona',
  'howItWorks.subtitle':
    'Da primeira conversa ao deployment completo em semanas, não meses.',
  'howItWorks.step0Title': 'Consultar',
  'howItWorks.step0Desc':
    'Analisamos as suas necessidades operacionais e objetivos únicos.',
  'howItWorks.step1Title': 'Configurar',
  'howItWorks.step1Desc':
    'Selecione e personalize os módulos que se adaptam ao seu negócio.',
  'howItWorks.step2Title': 'Implementar',
  'howItWorks.step2Desc':
    'Lance a sua plataforma com marca e comece a escalar.',

  // Pricing Teaser
  'pricingTeaser.title': 'Preços transparentes. Sem surpresas.',
  'pricingTeaser.desc':
    'Trippp é cobrado por produto, por deployment. Licenças anuais, configuração única e um modelo por operação para Trippp Ops. Sem taxas ocultas, sem caixas negras enterprise.',
  'pricingTeaser.cta': 'Ver todos os preços',

  // Final CTA
  'finalCTA.titlePart1': 'Tecnologia turística construída para quem ',
  'finalCTA.titleHighlight': 'constrói o destino',
  'finalCTA.desc':
    'Não adaptada de um SaaS genérico. Construída de raiz para como o turismo realmente funciona.',
  'finalCTA.cta': 'Agendar uma chamada de 30 minutos',

  // Footer
  'footer.tagline':
    'A plataforma tecnológica modular para o turismo que impulsiona a jornada completa.',
  'footer.products': 'Produtos',
  'footer.company': 'Empresa',
  'footer.aboutUs': 'Sobre nós',
  'footer.careers': 'Carreiras',
  'footer.blog': 'Blog',
  'footer.contact': 'Contacto',
  'footer.language': 'Idioma',
  'footer.copyright':
    '© {year} Trippp Technologies. Todos os direitos reservados.',
  'footer.privacy': 'Política de privacidade',
  'footer.terms': 'Termos de serviço',

  // Pricing Page
  'pricing.heroTitle': 'Preços transparentes. ',
  'pricing.heroTitleHighlight': 'Sem surpresas.',
  'pricing.heroDesc':
    'Cada produto tem uma licença anual clara. Sem taxas ocultas, sem caixas negras enterprise. Escolha o que precisa, saiba o que paga.',
  'pricing.mapTitle': 'Trippp Map',
  'pricing.mapSubtitle': 'Licença anual + configuração única',
  'pricing.sparkTitle': 'Trippp Spark',
  'pricing.sparkSubtitle': 'Licença anual + configuração única',
  'pricing.opsTitle': 'Trippp Ops',
  'pricing.opsSubtitle': 'Duas opções. Escale quando estiver pronto.',
  'pricing.tier': 'Nível',
  'pricing.annualLicense': 'Licença anual',
  'pricing.setup': 'Configuração (única)',
  'pricing.city': 'Cidade',
  'pricing.region': 'Região',
  'pricing.country': 'País / Multi-região',
  'pricing.hotelProperty': 'Hotel / Propriedade',
  'pricing.mapIncludes':
    'Inclui alojamento, acesso CMS, API, atualizações de plataforma e suporte multilingue.',
  'pricing.dmoTourismBoard': 'OGD / Organismo de turismo',
  'pricing.agency': 'Agência',
  'pricing.sparkIncludes':
    'Inclui alojamento, configuração em marca branca e atualizações da plataforma.',
  'pricing.platformLicense': 'Licença de plataforma',
  'pricing.perOperation': 'Por operação',
  'pricing.singleOperation': 'Operação única',
  'pricing.noCommitment': 'Sem compromisso',
  'pricing.oneTimeLabel': '(pagamento único)',
  'pricing.year': '/ ano',
  'pricing.op': '/ op',
  'pricing.platformLicenseDesc':
    'Acesso admin completo, CMS, kit de branding, contas de staff ilimitadas.',
  'pricing.perOperationDesc':
    'Linear. Sem níveis. Sem compromissos de volume. Cada operação pode ser em marca branca independentemente.',
  'pricing.singleOperationDesc':
    'Uma operação, um preço. Sem licença anual, sem compromisso. Ideal para um primeiro deployment ou uma viagem pontual.',
  'pricing.exampleNote':
    'Exemplo: uma agência que gere 10 operações por ano paga 4.800 € + 5.000 € = 9.800 €/ano.',
  'pricing.bundleNote': 'Usa mais do que um produto Trippp? ',
  'pricing.bundleHighlight': 'Pergunte-nos sobre preços de pacote.',
  'pricing.faqTitle': 'Perguntas frequentes',
  'pricing.faq0Q': 'O que está incluído na licença anual?',
  'pricing.faq0A':
    'Alojamento, atualizações de plataforma, acesso CMS, acesso API, configuração em marca branca e suporte multilingue. Tudo o que precisa para operar o produto.',
  'pricing.faq1Q': 'Quanto tempo demora o deployment?',
  'pricing.faq1A':
    'Normalmente 2 a 4 semanas desde o início até ao lançamento, dependendo da disponibilidade do conteúdo e do âmbito.',
  'pricing.faq2Q': 'Posso começar com um produto e adicionar outros depois?',
  'pricing.faq2A':
    'Sim. Cada produto é independente. Adicione Map, Spark ou Trippp Ops quando estiver pronto.',
  'pricing.faq3Q': 'Existe um período de compromisso?',
  'pricing.faq3A':
    'As licenças são anuais. Sem compromisso plurianual obrigatório.',
  'pricing.ctaTitle': 'Conheça o preço. Veja o produto. ',
  'pricing.ctaHighlight': 'Decida com clareza.',
  'pricing.ctaCta': 'Agendar uma chamada de 30 minutos',

  // About Page
  'about.heroTitle': 'Construímos tecnologia para quem ',
  'about.heroTitleHighlight': 'constrói destinos.',
  'about.heroDesc':
    'Trippp nasceu de deployments reais em destinos reais. Não de um pitch deck — do terreno.',
  'about.originTitle': 'De onde vem o Trippp.',
  'about.originP1':
    'Trippp começou como um conjunto de ferramentas construídas para organismos de turismo que precisavam de infraestrutura digital real — não mais um site template, não mais uma brochura PDF.',
  'about.originP2':
    'Mapas interativos, experiências de descoberta cinematográficas e plataformas operacionais foram desenhados, implementados e testados em destinos reais antes de Trippp se tornar uma empresa de produto.',
  'about.originP3':
    'Cada funcionalidade existe porque um cliente precisou dela no mundo real.',
  'about.beliefsTitle': 'Três coisas que defendemos.',
  'about.belief0Title': 'Construído para o turismo, não adaptado.',
  'about.belief0Desc':
    'Ferramentas SaaS genéricas forçam os profissionais de turismo a adaptar o seu fluxo de trabalho. Trippp foi desenhado desde o primeiro dia em torno de como destinos, agências e hotéis realmente operam.',
  'about.belief1Title': 'Modular por design.',
  'about.belief1Desc':
    'Ninguém precisa de tudo no primeiro dia. Escolha um produto, adicione mais quando fizer sentido. Sem pacotes forçados, sem pacotes inchados.',
  'about.belief2Title': 'Marca branca por defeito.',
  'about.belief2Desc':
    'A sua marca, o seu domínio, a sua identidade. Trippp desaparece atrás do nome que escolher colocar à frente.',
  'about.deployedTitle': 'Implementado. Online. A funcionar.',
  'about.deployment0Title': 'Visit Beni Mellal-Khénifra',
  'about.deployment0Desc':
    'Mapa interativo regional e descoberta cinematográfica.',
  'about.deployment1Title': 'Visit Draa-Tafilalet',
  'about.deployment1Desc':
    'Cartografia de um vasto território, totalmente multilingue.',
  'about.deployment2Title': 'Lumi Morocco',
  'about.deployment2Desc':
    'App para viajantes em marca branca e painel de operações.',
  'about.seeItLive': 'Ver ao vivo',
  'about.ctaTitle': 'Quer ver o que Trippp pode fazer pelo ',
  'about.ctaHighlight': 'seu destino?',
  'about.ctaCta': 'Agendar uma chamada de 30 minutos',

  // Contact Page
  'contact.heroTitle': 'Vamos ',
  'contact.heroTitleHighlight': 'conversar.',
  'contact.heroDesc':
    'Tem uma pergunta, uma necessidade específica ou simplesmente quer saber mais? Escreva-nos diretamente.',
  'contact.nameLabel': 'Nome',
  'contact.namePlaceholder': 'João Silva',
  'contact.emailLabel': 'Email',
  'contact.emailPlaceholder': 'joao@exemplo.com',
  'contact.companyLabel': 'Empresa',
  'contact.companyPlaceholder': 'Nome da empresa',
  'contact.roleLabel': 'Função',
  'contact.roleSelectRole': 'Selecionar função...',
  'contact.roleDmo': 'OGD e Organismo de turismo',
  'contact.roleAgency': 'DMC e Agência de viagem',
  'contact.roleHotel': 'Hotel e Resort',
  'contact.roleRealestate': 'Promotor imobiliário',
  'contact.roleOther': 'Outro',
  'contact.messageLabel': 'Mensagem',
  'contact.messagePlaceholder': 'Como podemos ajudar?',
  'contact.sendMessage': 'Enviar mensagem',
  'contact.responseTime': 'Normalmente respondemos em 24 horas.',
  'contact.demoTitle': 'Prefere ver o produto ao vivo?',
  'contact.demoDesc':
    'Sem slides. Sem pitch deck. Mostramos-lhe o produto real a funcionar em destinos reais.',
  'contact.demoCta': 'Agendar uma chamada de 30 minutos →',
  'contact.faqTitle': 'Perguntas ',
  'contact.faqHighlight': 'frequentes',
  'contact.faq0Q': 'O que acontece durante a demo?',
  'contact.faq0A':
    'Mostramos-lhe o produto ao vivo — Map, Spark ou Trippp Ops conforme as suas necessidades — a funcionar em deployments reais de destinos. Sem mockups.',
  'contact.faq1Q': 'Preciso de preparar alguma coisa?',
  'contact.faq1A':
    'Não. Traga apenas as suas perguntas. Se quiser que nos foquemos num produto específico, mencione-o ao agendar.',
  'contact.faq2Q': 'É uma chamada de vendas?',
  'contact.faq2A':
    'É uma apresentação de produto. Verá exatamente o que obteria. Os preços estão no nosso site — sem surpresas.',

  // Trippp Map Page
  'tripppMap.badge': 'Trippp Map',
  'tripppMap.heroTitle':
    'Cada ponto de interesse. Cada trilho. Cada história. ',
  'tripppMap.heroTitleHighlight': 'Um só mapa.',
  'tripppMap.heroDesc':
    'Trippp Map é um mapa interativo de destino em marca branca, impulsionado por um CMS dedicado. Implemente-o para uma cidade, uma região ou um país inteiro — totalmente com a sua marca, multilingue e pronto em semanas.',
  'tripppMap.bookDemo': 'Agendar uma demo',
  'tripppMap.seeItLive': 'Ver ao vivo',
  'tripppMap.featuresTitle':
    'Tudo o que um destino precisa numa só plataforma.',
  'tripppMap.feature0Title': 'Mapa interativo',
  'tripppMap.feature0Desc':
    'Um mapa totalmente navegável com estilo personalizado, pontos de interesse filtráveis e experiência móvel fluida.',
  'tripppMap.feature1Title': 'Itinerários selecionados',
  'tripppMap.feature1Desc':
    'Rotas de viagem pré-construídas que guiam os visitantes pelo seu destino dia a dia.',
  'tripppMap.feature2Title': 'Módulo de caminhada e trilhos',
  'tripppMap.feature2Desc':
    'Trilhos GPS com desnível, distância, dificuldade e rotas descarregáveis.',
  'tripppMap.feature3Title': 'Conteúdo multilingue',
  'tripppMap.feature3Desc':
    'Cada conteúdo traduzível para o idioma que a sua audiência precisa — impulsionado por IA.',
  'tripppMap.feature4Title': 'CMS dedicado',
  'tripppMap.feature4Desc':
    'Um back-office construído especificamente para o turismo — gira lugares, tags, tours, ofertas, artigos e media a partir de um só painel.',
  'tripppMap.feature5Title': 'Progressive Web App',
  'tripppMap.feature5Desc':
    'Instalável em qualquer telemóvel. Funciona offline. Envia notificações. Sem necessidade de app store.',
  'tripppMap.targetsTitle': 'Construído para destinos de qualquer escala.',
  'tripppMap.target0Title': 'Cidade',
  'tripppMap.target0Desc':
    'Um município ou destino urbano que procura digitalizar a sua experiência de visitante.',
  'tripppMap.target1Title': 'Região',
  'tripppMap.target1Desc':
    'Uma província, governação ou território multi-cidade com atrações diversas para organizar e promover.',
  'tripppMap.target2Title': 'País',
  'tripppMap.target2Desc':
    'Um organismo nacional de turismo a implementar um mapa digital unificado em múltiplas regiões.',
  'tripppMap.target3Title': 'Hotel / Propriedade',
  'tripppMap.target3Desc':
    'Um resort ou hotel a mostrar os arredores e experiências locais disponíveis para os hóspedes.',
  'tripppMap.deploymentsTitle': 'Trippp Map no mundo real.',
  'tripppMap.deployment0Title': 'Visit Beni Mellal-Khénifra',
  'tripppMap.deployment0Desc':
    'Um organismo de turismo regional em Marrocos que cobre montanhas, cascatas, vales e cidades históricas. Mapa implementado com CMS completo, conteúdo multilingue, itinerários, trilhos de caminhada e ofertas selecionadas.',
  'tripppMap.deployment1Title': 'Visit Draa-Tafilalet',
  'tripppMap.deployment1Desc':
    'A porta de entrada para o Saara em Marrocos. Mapa interativo que abrange um vasto território de oásis, kasbahs, rotas desérticas e trilhos de trekking — tudo totalmente multilingue.',
  'tripppMap.exploreTheMap': 'Explorar o mapa',
  'tripppMap.techTitle': 'Sob o capô.',
  'tripppMap.tech0':
    'Arquitetura API REST — cada dado acessível através de endpoints documentados',
  'tripppMap.tech1': 'Mapbox GL JS com estilo cartográfico personalizado',
  'tripppMap.tech2': 'Media alojada na AWS com distribuição CDN',
  'tripppMap.tech3': 'Conteúdo MongoDB com sincronização CMS em tempo real',
  'tripppMap.tech4': 'Documentação Swagger/OpenAPI incluída',
  'tripppMap.tech5': 'Marca branca: o seu domínio, o seu logo, as suas cores',
  'tripppMap.ctaTitle': 'Pronto para colocar o seu destino ',
  'tripppMap.ctaHighlight': 'no mapa?',
  'tripppMap.ctaCta': 'Agendar uma chamada de 30 minutos',

  // Trippp Spark Page
  'tripppSpark.badge': 'Trippp Spark',
  'tripppSpark.heroTitle': 'Antes de pesquisar. Antes de reservar. ',
  'tripppSpark.heroTitleHighlight': 'Sentem.',
  'tripppSpark.heroDesc':
    'Trippp Spark é uma experiência de descoberta cinematográfica baseada em emoções. Os viajantes não filtram por data ou preço — deslizam por histórias visuais até que um destino lhes fale. Personalize-a com a sua marca e integre-a em qualquer lugar.',
  'tripppSpark.bookDemo': 'Agendar uma demo',
  'tripppSpark.experienceItLive': 'Viver a experiência ao vivo',
  'tripppSpark.howItWorksTitle':
    'Descoberta através da emoção, não da logística.',
  'tripppSpark.step0Title': 'Sentir',
  'tripppSpark.step0Desc':
    'Os visitantes chegam a uma experiência visual imersiva em ecrã inteiro. Sem menus. Sem barras de pesquisa. Apenas imagens e emoção.',
  'tripppSpark.step1Title': 'Explorar',
  'tripppSpark.step1Desc':
    'Deslizam, fazem scroll e tocam em categorias visuais — aventura, serenidade, cultura, vida noturna — descobrindo lugares pelo que sentem, não por onde estão.',
  'tripppSpark.step2Title': 'Conectar',
  'tripppSpark.step2Desc':
    'Cada experiência liga a conteúdo detalhado — lugares, histórias, info prática — ligando emoção a ação.',
  'tripppSpark.targetsTitle':
    'Spark vive onde as primeiras impressões importam.',
  'tripppSpark.target0Title': 'OGD / Organismo de turismo',
  'tripppSpark.target0Desc':
    'Implemente Spark como a porta emocional do seu destino. Uma experiência cinematográfica completa que cobre tudo o que a sua região oferece, totalmente com a sua marca.',
  'tripppSpark.target1Title': 'Hotel / Resort',
  'tripppSpark.target1Desc':
    'Integre Spark no seu site. Deixe os potenciais hóspedes sentir a propriedade e os seus arredores antes de verificar disponibilidade.',
  'tripppSpark.target2Title': 'Agência',
  'tripppSpark.target2Desc':
    'Adicione Spark como página de experiência nos seus sites para clientes. Diferencie a sua marca com uma camada de descoberta que nenhum concorrente tem.',
  'tripppSpark.deploymentTitle': 'Trippp Spark no mundo real.',
  'tripppSpark.deployment0Title':
    'Visit Beni Mellal-Khénifra — Modo Inspiração',
  'tripppSpark.deployment0Desc':
    'O organismo de turismo regional implementou Spark ao lado de Map para criar uma experiência dual: os visitantes podem explorar logicamente através de Map ou emocionalmente através de Spark. Ambas as plataformas partilham a mesma API e conteúdo CMS.',
  'tripppSpark.experienceIt': 'Viver a experiência',
  'tripppSpark.differentTitle':
    'Não é uma galeria. Não é um slider. Um novo formato.',
  'tripppSpark.diff0':
    'Ecrã inteiro, cinematográfico primeiro. Desenhado para ser sentido, não escaneado.',
  'tripppSpark.diff1':
    'Conteúdo impulsionado pelo mesmo CMS e API que Trippp Map. Uma só fonte de verdade.',
  'tripppSpark.diff2':
    'Marca branca: a sua marca, o seu domínio, a sua identidade visual.',
  'tripppSpark.diff3':
    'Integrável como página autónoma ou em qualquer site existente.',
  'tripppSpark.ctaTitle': 'Dê à sua audiência uma razão para sonhar ',
  'tripppSpark.ctaHighlight': 'antes de planear.',
  'tripppSpark.ctaCta': 'Agendar uma chamada de 30 minutos',

  // Trippp Ops Page
  'tripppOps.badge': 'Trippp Ops',
  'tripppOps.heroTitle': 'Uma app para o viajante. Um painel para a agência. ',
  'tripppOps.heroTitleHighlight': 'Clareza total para todos.',
  'tripppOps.heroDesc':
    'Trippp Ops é uma app para viajantes e plataforma operacional em marca branca. Para cada operação, os seus viajantes obtêm o programa completo, marketplace de extras, documentos e contactos de emergência. A sua equipa obtém visibilidade de reservas, seguimento de comissões e mensagens broadcast. Com marca diferente para cada viagem se necessário.',
  'tripppOps.bookDemo': 'Agendar uma demo',
  'tripppOps.seeHowItWorks': 'Ver como funciona',
  'tripppOps.travelerTitle': 'O que os seus viajantes veem.',
  'tripppOps.traveler0Title': 'Programa da viagem',
  'tripppOps.traveler0Desc':
    'Itinerário dia a dia acessível através de um código de viagem único. Sem necessidade de descarregar app.',
  'tripppOps.traveler1Title': 'Marketplace de extras',
  'tripppOps.traveler1Desc':
    'Transfers, excursões, spa, restaurantes — os viajantes navegam e reservam serviços opcionais diretamente.',
  'tripppOps.traveler2Title': 'Biblioteca de documentos',
  'tripppOps.traveler2Desc':
    'Vouchers, bilhetes, seguro de viagem, info prática — tudo num só lugar.',
  'tripppOps.traveler3Title': 'Contactos de emergência',
  'tripppOps.traveler3Desc':
    'Números de emergência locais, contactos da agência, info do hotel — sempre acessíveis.',
  'tripppOps.traveler4Title': 'Partilha de media',
  'tripppOps.traveler4Desc':
    'Fotos e memórias partilhadas dentro do grupo de viagem.',
  'tripppOps.traveler5Title': 'Multilingue',
  'tripppOps.traveler5Desc':
    'Disponível em qualquer idioma — tradução impulsionada por IA para cada audiência.',
  'tripppOps.agencyTitle': 'O que a sua equipa controla.',
  'tripppOps.agency0Title': 'Criação de viagem',
  'tripppOps.agency0Desc':
    'Crie uma nova operação em minutos. Defina o programa, configure os extras disponíveis, atribua participantes.',
  'tripppOps.agency1Title': 'Marca branca por operação',
  'tripppOps.agency1Desc':
    'Cada viagem pode ter uma marca diferente — a sua, a do seu parceiro ou a do seu cliente. Logo, cores, domínio.',
  'tripppOps.agency2Title': 'Seguimento de reservas e comissões',
  'tripppOps.agency2Desc':
    'Veja cada extra reservado, cada serviço vendido. Siga as comissões em tempo real em todas as operações.',
  'tripppOps.agency3Title': 'Gestão de participantes',
  'tripppOps.agency3Desc':
    'Adicione viajantes, gira acessos, monitorize o engagement por operação.',
  'tripppOps.agency4Title': 'Mensagens broadcast',
  'tripppOps.agency4Desc':
    'Envie atualizações a todos os viajantes de uma operação via notificações WhatsApp.',
  'tripppOps.mandatesTitle': 'A ferramenta que ganha mandatos.',
  'tripppOps.scenario0':
    'Uma agência brasileira manda Trippp Ops ao seu fornecedor DMC marroquino. Cada operação em Marrocos passa pela plataforma — em marca branca sob a marca da agência brasileira. A agência tem visibilidade completa sobre os extras vendidos e as comissões ganhas, mesmo a 10.000 km de distância.',
  'tripppOps.scenario1':
    'Um DMC marroquino propõe a uma agência internacional uma viagem incentivo de 200 pessoas. O seu diferenciador? Uma app para viajantes com marca, com um marketplace de serviços completo, acesso a documentos e atualizações em tempo real. A agência escolhe-o face a três concorrentes que ofereciam folhas de cálculo e PDFs.',
  'tripppOps.deploymentTitle': 'Trippp Ops no mundo real.',
  'tripppOps.deployment0Title': 'Lumi Morocco',
  'tripppOps.deployment0Desc':
    'Um DMC marroquino implementou Trippp Ops para servir os seus clientes agências internacionais. Os viajantes acedem à sua viagem completa sob a marca Lumi — programa, extras, documentos, contactos de emergência — enquanto a equipa Lumi gere reservas, segue comissões e comunica em tempo real.',
  'tripppOps.learnMore': 'Saber mais',
  'tripppOps.pricingTitle': 'Preços simples. Escala com as suas operações.',
  'tripppOps.platformLicense': 'Licença de plataforma',
  'tripppOps.perOperation': 'Por operação',
  'tripppOps.noPriceNote':
    'Sem taxas ocultas. Sem compromissos de volume. Paga quando opera.',
  'tripppOps.seeFullPricing': 'Ver todos os preços',
  'tripppOps.ctaTitle': 'Pare de gerir viagens em folhas de cálculo. ',
  'tripppOps.ctaHighlight': 'Comece a dirigir operações.',
  'tripppOps.ctaCta': 'Agendar uma chamada de 30 minutos',

  // Use Case DMO Page
  'useCaseDMO.badge': 'OGD e Organismos de turismo',
  'useCaseDMO.heroTitle': 'O seu destino merece mais do que um ',
  'useCaseDMO.heroTitleHighlight': 'site de brochura.',
  'useCaseDMO.heroDesc':
    'Trippp oferece aos organismos de turismo uma plataforma digital modular: um mapa interativo, uma experiência de descoberta cinematográfica e um sistema de gestão de conteúdo completo — tudo em marca branca, multilingue e implementável em semanas.',
  'useCaseDMO.bookDemo': 'Agendar uma demo',
  'useCaseDMO.challengeTitle': 'O que os OGD enfrentam hoje.',
  'useCaseDMO.pain0':
    'Sites estáticos que nenhum viajante guarda nos favoritos.',
  'useCaseDMO.pain1':
    'Conteúdo disperso entre PDFs, redes sociais e plataformas de terceiros que não controla.',
  'useCaseDMO.pain2':
    'Zero infraestrutura digital para competir com destinos que têm 10 vezes o seu orçamento.',
  'useCaseDMO.solutionTitle':
    'Map + Spark: a espinha dorsal digital do seu destino.',
  'useCaseDMO.mapDesc':
    'Ofereça aos visitantes um mapa navegável, filtrável e multilingue de tudo o que a sua região oferece. Gira todo o conteúdo através de um CMS específico para turismo — lugares, itinerários, trilhos de caminhada, ofertas, artigos.',
  'useCaseDMO.sparkDesc':
    'Crie uma primeira impressão emocional. Uma experiência cinematográfica e deslizável que faz os viajantes sentir o seu destino antes de planear. Integrável, personalizável, partilhável.',
  'useCaseDMO.sharedNote':
    '"Ambos os produtos partilham o mesmo CMS e API. Um só esforço de conteúdo alimenta duas experiências."',
  'useCaseDMO.deploymentsTitle': 'Deployments reais.',
  'useCaseDMO.deployment0Title': 'Visit Beni Mellal-Khénifra',
  'useCaseDMO.deployment0Desc':
    'Um organismo de turismo regional em Marrocos implementou Trippp Map e Spark para digitalizar um destino anteriormente pouco promovido — oferecendo aos visitantes uma janela interativa e multilingue para as montanhas, vales e cultura da região.',
  'useCaseDMO.deployment1Title': 'Visit Draa-Tafilalet',
  'useCaseDMO.deployment1Desc':
    'A porta de entrada para o Saara em Marrocos agora tem um mapa interativo que cobre o seu vasto território — cidades, oásis, kasbahs e rotas de trekking, tudo totalmente multilingue.',
  'useCaseDMO.seeItLive': 'Ver ao vivo',
  'useCaseDMO.whatYouGetTitle': 'O que obtém.',
  'useCaseDMO.check0': 'Plataforma em marca branca sob a sua marca de destino',
  'useCaseDMO.check1': 'CMS dedicado construído para conteúdo turístico',
  'useCaseDMO.check2': 'Multilingue — qualquer idioma, impulsionado por IA',
  'useCaseDMO.check3': 'API REST com documentação pública',
  'useCaseDMO.check4': 'PWA — instalável, funciona offline, sem app store',
  'useCaseDMO.check5':
    'Alojamento contínuo e atualizações de plataforma incluídas',
  'useCaseDMO.ctaTitle': 'Coloque a sua região no mapa digital. ',
  'useCaseDMO.ctaHighlight': 'Literalmente.',
  'useCaseDMO.ctaCta': 'Agendar uma chamada de 30 minutos',

  // Use Case DMC Page
  'useCaseDMC.badge': 'DMC e Agências de viagem',
  'useCaseDMC.heroTitle': 'Gira operações que impressionem os seus clientes e ',
  'useCaseDMC.heroTitleHighlight': 'assegure as suas comissões.',
  'useCaseDMC.heroDesc':
    'Trippp Ops oferece à sua agência uma app para viajantes em marca branca e um painel de operações para cada viagem. Os seus viajantes obtêm uma experiência fluida durante a viagem. A sua equipa obtém visibilidade completa sobre reservas, extras e comissões.',
  'useCaseDMC.bookDemo': 'Agendar uma demo',
  'useCaseDMC.challengeTitle': 'O que os DMC enfrentam hoje.',
  'useCaseDMC.pain0':
    'Gerir a logística de viagens entre grupos WhatsApp, emails e documentos partilhados.',
  'useCaseDMC.pain1':
    'Sem visibilidade sobre que extras os viajantes compram — e sem forma de capturar comissões.',
  'useCaseDMC.pain2':
    'Perder mandatos internacionais para concorrentes que parecem mais profissionais digitalmente.',
  'useCaseDMC.solutionTitle': 'Trippp Ops: uma plataforma para cada operação.',
  'useCaseDMC.travelerAppTitle': 'Funcionalidades da app para viajantes',
  'useCaseDMC.travelerFeature0': 'Programa e itinerário',
  'useCaseDMC.travelerFeature1': 'Marketplace de extras',
  'useCaseDMC.travelerFeature2': 'Biblioteca de documentos',
  'useCaseDMC.travelerFeature3': 'Contactos de emergência',
  'useCaseDMC.adminDashboardTitle':
    'Funcionalidades do painel de administração',
  'useCaseDMC.adminFeature0': 'Criação e gestão de viagens',
  'useCaseDMC.adminFeature1': 'Marca branca por operação',
  'useCaseDMC.adminFeature2': 'Seguimento de reservas e comissões',
  'useCaseDMC.adminFeature3': 'Mensagens broadcast',
  'useCaseDMC.whiteLabelNote':
    '"Cada operação pode ser em marca branca com uma marca diferente — a sua, a do seu parceiro ou a da agência do seu cliente. Mesma plataforma, cara diferente."',
  'useCaseDMC.edgeTitle':
    'Ganhe mandatos. Mantenha comissões. Pareça de classe mundial.',
  'useCaseDMC.scenario0':
    'Uma agência brasileira manda Trippp Ops ao seu fornecedor DMC marroquino. Cada operação em Marrocos passa pela plataforma — em marca branca sob a marca da agência brasileira. A agência tem visibilidade completa sobre os extras vendidos e as comissões ganhas, mesmo a 10.000 km.',
  'useCaseDMC.scenario1':
    'Um DMC marroquino propõe a uma agência internacional uma viagem incentivo de 200 pessoas. O seu diferenciador? Uma app para viajantes com marca, com um marketplace de serviços completo, acesso a documentos e atualizações em tempo real. A agência escolhe-o face a três concorrentes que ofereciam folhas de cálculo e PDFs.',
  'useCaseDMC.deploymentTitle': 'Deployment real.',
  'useCaseDMC.deployment0Title': 'Lumi Morocco',
  'useCaseDMC.deployment0Desc':
    'Um DMC marroquino implementou Trippp Ops para oferecer aos viajantes dos seus clientes internacionais uma experiência de viagem totalmente com marca — programa, extras, documentos e comunicação em tempo real, tudo sob a marca Lumi.',
  'useCaseDMC.learnMore': 'Saber mais',
  'useCaseDMC.pricingTitle': 'Preços simples. Escala com as suas operações.',
  'useCaseDMC.platformLicense': 'Licença de plataforma',
  'useCaseDMC.perOperation': 'Por operação',
  'useCaseDMC.seeFullPricing': 'Ver todos os preços',
  'useCaseDMC.ctaTitle':
    'O seu próximo cliente escolhe entre si e um concorrente que trabalha com folhas de cálculo. ',
  'useCaseDMC.ctaHighlight': 'Torne-o óbvio.',
  'useCaseDMC.ctaCta': 'Agendar uma chamada de 30 minutos',

  // Use Case Hotels Page
  'useCaseHotels.badge': 'Hotéis e Resorts',
  'useCaseHotels.heroTitle': 'Os seus hóspedes querem explorar. ',
  'useCaseHotels.heroTitleHighlight': 'Dê-lhes uma razão para começar consigo.',
  'useCaseHotels.heroDesc':
    'Trippp oferece a hotéis e resorts duas ferramentas para enriquecer a experiência do hóspede: um mapa interativo do destino envolvente e uma experiência de descoberta cinematográfica — ambas integráveis no seu site, ambas com a sua marca.',
  'useCaseHotels.bookDemo': 'Agendar uma demo',
  'useCaseHotels.challengeTitle': 'O que os hotéis enfrentam hoje.',
  'useCaseHotels.pain0':
    'Um belo site de hotel que para no lobby. Nada sobre o que o rodeia.',
  'useCaseHotels.pain1':
    'Os hóspedes descobrem o destino no TripAdvisor ou Google — não através da sua marca.',
  'useCaseHotels.pain2':
    'Sem forma de se diferenciar além de fotos de quartos e listas de comodidades.',
  'useCaseHotels.solutionTitle': 'A solução Trippp.',
  'useCaseHotels.mapTitle': 'Trippp Map — Nível Propriedade',
  'useCaseHotels.mapDesc':
    'Um mapa interativo dos seus arredores. Restaurantes, atividades, locais culturais, praias, trilhos — selecionados por si, apresentados sob a sua marca. Os hóspedes exploram o destino através do seu olhar.',
  'useCaseHotels.sparkTitle': 'Trippp Spark — Nível Propriedade',
  'useCaseHotels.sparkDesc':
    'Uma página cinematográfica no seu site que permite aos futuros hóspedes sentir o destino emocionalmente. Não uma galeria de fotos — uma experiência de descoberta em ecrã inteiro, deslizável e baseada em emoções.',
  'useCaseHotels.fitsTitle': 'Integrado sem costuras. Com marca completa.',
  'useCaseHotels.fit0':
    'Spark torna-se uma página no seu site — "Explorar o destino" — que nenhum hotel concorrente tem.',
  'useCaseHotels.fit1':
    'Map vive como um guia interativo que os hóspedes podem consultar antes e durante a estadia.',
  'useCaseHotels.fit2':
    'Ambos levam o logo, cores e domínio do seu hotel. Os visitantes nunca abandonam a sua marca.',
  'useCaseHotels.ctaTitle': 'Pare de vender quartos. ',
  'useCaseHotels.ctaHighlight': 'Comece a vender a experiência que os rodeia.',
  'useCaseHotels.ctaCta': 'Agendar uma chamada de 30 minutos',

  // Use Case Real Estate Page
  'useCaseRealEstate.badge': 'Imobiliário e Lifestyle',
  'useCaseRealEstate.heroTitle': 'Não vende metros quadrados. ',
  'useCaseRealEstate.heroTitleHighlight': 'Vende um estilo de vida.',
  'useCaseRealEstate.heroDesc':
    'Trippp oferece a promotores imobiliários e lifestyle ferramentas para mostrar o destino em torno da propriedade — trilhos, restaurantes, cultura, experiências — transformando a localização de uma linha num argumento principal.',
  'useCaseRealEstate.bookDemo': 'Agendar uma demo',
  'useCaseRealEstate.challengeTitle': 'O que os promotores enfrentam hoje.',
  'useCaseRealEstate.pain0':
    'Os compradores veem plantas e renders. Não sentem o estilo de vida.',
  'useCaseRealEstate.pain1':
    'A localização é mencionada como um ponto, nunca como uma experiência.',
  'useCaseRealEstate.pain2':
    'Desenvolvimentos concorrentes na mesma área parecem todos iguais no papel.',
  'useCaseRealEstate.solutionTitle': 'A solução Trippp.',
  'useCaseRealEstate.mapDesc':
    'Um mapa interativo dos arredores — restaurantes, atividades ao ar livre, locais culturais, escolas, transportes. Os compradores potenciais exploram o bairro através de um olhar selecionado e com marca.',
  'useCaseRealEstate.sparkDesc':
    'Uma experiência cinematográfica que faz os compradores sentir o estilo de vida antes de visitar o showroom. Os trilhos de montanha ao nascer do sol. Os restaurantes costeiros ao pôr do sol. A cena cultural aos fins de semana.',
  'useCaseRealEstate.impactTitle': 'Faça do ambiente parte do argumento.',
  'useCaseRealEstate.impact0':
    'Quando dois desenvolvimentos oferecem especificações semelhantes a preços semelhantes, o que vende o estilo de vida ganha. Trippp torna o estilo de vida tangível.',
  'useCaseRealEstate.impact1':
    'Integre Map e Spark no seu site de vendas, nas suas brochuras, nos seus ecrãs de showroom. Cada ponto de contacto torna-se um argumento imersivo.',
  'useCaseRealEstate.ctaTitle': 'Venda a vista. Venda o trilho. ',
  'useCaseRealEstate.ctaHighlight': 'Venda o sábado de manhã.',
  'useCaseRealEstate.ctaCta': 'Agendar uma chamada de 30 minutos',
}
